import React, { useEffect, useState } from "react"
import NotificationIcon from '../../../assets/images/Icons/alerts-notification-icon.svg'
import { Image, Dropdown, OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { convertToBaseFormatDate } from "../../../commonservices/CommonMethods";
import SharedChips from "../common/components/Chips/SharedChips";
import exportlogo from '../../../assets/images/TableFilters/TableFilterDownloadIcon.svg';
import NoDataFound from "../common/components/TableComponents/NoDataFound/NoDataFound";
import { X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { getCsvDownload, getNotifications, getOnClose } from "../../../store/Actions/Lender/Inventory";

const Notifications = () => {
    const { notificationData, hideNotificationIcon, isNotificationInProgress } = useSelector((store) => store.sharedReducer)
    const dispatch = useDispatch();


    useEffect(() => {
        let interval
        if (isNotificationInProgress) {
            interval = setInterval(() => dispatch(getNotifications()), 30000);
        }
        return () => {
            clearInterval(interval);
        }
    }, [isNotificationInProgress])

    useEffect(() => {
        dispatch(getNotifications())
    }, [])



    return (
        <>
            <Dropdown alignRight={true} className={hideNotificationIcon ? "d-none" : "mr-3 header-icons"}>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className='notifications-toggle complete-payment-btn'>
                    <OverlayTrigger placement='bottom' overlay={<Tooltip>Notifications</Tooltip>}>
                        <span>
                            <span className="number-count-value">{notificationData?.length ?? 0}</span>
                            <Image src={NotificationIcon} fluid alt='Search-Icon' className='search-icon-header cursor-pointer' />
                        </span>
                    </OverlayTrigger>
                </Dropdown.Toggle>
                {notificationData?.length > 0 ? <Dropdown.Menu popperConfig={{ strategy: "fixed" }}>
                    <Row className="mx-0 p-16-20px border-bottom-E6E8F0">
                        <Col className='p-0'><h6 className="widget-title widget-title-color">{`Notifications (${notificationData?.length ?? 0})`}</h6></Col>
                    </Row>
                    <div className="content-section">
                        <Row className="mx-0">
                            <Col xs={12} className="p-0 header-cart-items">
                                {notificationData.length > 0 ?
                                    notificationData.map((item, index) => {
                                        return (
                                            <Row key={'paymentsCartHeader' + index} className="mx-0 p-10-20px border-bottom-E6E8F0">
                                                <Col xs={10} className="p-0">
                                                    {item?.title ? <b className='mr-1 vehicle-name-cart'>{item?.title ?? ''} </b> : null}
                                                    <SharedChips
                                                        label={item?.status.includes('Download') ? 'Completed' : item?.status}
                                                        color={item?.status.includes('Download') ? 'green' : item?.status === 'In Progress' ? 'brown' : 'red'}
                                                        inlineBlock={true}
                                                        categoryName='Notification'
                                                    />
                                                    <small className='d-block secondary-text-color'>{item?.description ?? ''}</small>
                                                    <small className='d-block secondary-text-color'>{item?.createdAt ? convertToBaseFormatDate(item.createdAt, true, true) : ''}</small>
                                                </Col>
                                                <Col xs={2} className="px-0 text-right">
                                                    {item?.status.includes('Download') ?
                                                        <OverlayTrigger overlay={<Tooltip>Download</Tooltip>}>
                                                            <img src={exportlogo} className='cursor-pointer icon-size-17px' alt="printlogo" onClick={(e) => (e.detail === 1) ? dispatch(getCsvDownload(item)) : null} />
                                                        </OverlayTrigger> :
                                                        item?.status?.includes('Failed') ?
                                                            <OverlayTrigger overlay={<Tooltip>Cancel</Tooltip>}>
                                                                <X className='cursor-pointer icon-color' size={17} onClick={() => dispatch(getOnClose(item))} /></OverlayTrigger> : null}
                                                </Col>
                                            </Row>
                                        )

                                    }) : <NoDataFound message={'No data'} />
                                }
                            </Col>
                        </Row>
                    </div>
                </Dropdown.Menu> : null
                }
            </Dropdown >
        </>
    )
}

export default Notifications
